var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootcampjslevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ujq4kkxgga)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#gru0nr4whb)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.54 1.969c1.607 0 2.866 0 3.866.108 1.02.11 1.846.34 2.551.853.427.31.803.686 1.113 1.113.513.705.742 1.532.853 2.551.108 1 .108 2.26.108 3.866v.08c0 1.607 0 2.866-.108 3.866-.11 1.02-.34 1.846-.853 2.551-.31.427-.686.803-1.113 1.113-.705.513-1.532.742-2.551.853-1 .108-2.26.108-3.866.108h-.08c-1.607 0-2.866 0-3.866-.108-1.02-.11-1.846-.34-2.551-.853a5.034 5.034 0 0 1-1.113-1.113c-.513-.705-.742-1.532-.853-2.551-.108-1-.108-2.26-.108-3.866v-.08c0-1.607 0-2.866.108-3.866.11-1.02.34-1.846.853-2.551.31-.427.686-.803 1.113-1.113.705-.513 1.532-.742 2.551-.853 1-.108 2.26-.108 3.866-.108h.08z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.54 1.969c1.607 0 2.866 0 3.866.108 1.02.11 1.846.34 2.551.853.427.31.803.686 1.113 1.113.513.705.742 1.532.853 2.551.108 1 .108 2.26.108 3.866v.08c0 1.607 0 2.866-.108 3.866-.11 1.02-.34 1.846-.853 2.551-.31.427-.686.803-1.113 1.113-.705.513-1.532.742-2.551.853-1 .108-2.26.108-3.866.108h-.08c-1.607 0-2.866 0-3.866-.108-1.02-.11-1.846-.34-2.551-.853a5.034 5.034 0 0 1-1.113-1.113c-.513-.705-.742-1.532-.853-2.551-.108-1-.108-2.26-.108-3.866v-.08c0-1.607 0-2.866.108-3.866.11-1.02.34-1.846.853-2.551.31-.427.686-.803 1.113-1.113.705-.513 1.532-.742 2.551-.853 1-.108 2.26-.108 3.866-.108h.08z",
    stroke: "url(#dqss0vxqlc)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#0hii7u269d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.464 8.289a.656.656 0 1 0-1.178-.578l-1.278 2.605c-.396.807-1.56.768-1.9-.065-.77-1.88-3.4-1.97-4.294-.145l-1.278 2.605a.656.656 0 1 0 1.178.578l1.278-2.605c.396-.807 1.56-.768 1.9.064.77 1.88 3.4 1.97 4.295.146l1.277-2.605z",
    fill: "#062A6A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "gru0nr4whb",
    x: -22.531,
    y: -22.531,
    width: 66.063,
    height: 66.063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_400_1527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_400_1527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "0hii7u269d",
    x: 2.469,
    y: 4.344,
    width: 26.063,
    height: 22.313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_400_1527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_400_1527",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dqss0vxqlc",
    x1: 1.969,
    y1: 1.969,
    x2: 19.04,
    y2: 19.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ujq4kkxgga"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v21H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjslevel);
export default __webpack_public_path__ + "static/media/Bootcamp js level.36528a78933068f64af8655ab227bcde.svg";
export { ForwardRef as ReactComponent };